import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface EqualHeightContainerStyles {
    container?: InjectableCss;
}

export const EqualHeightContainerStyles: EqualHeightContainerStyles = {
    container: {
        css: css`
            background: #fff;
            padding: 0;
            > div[class^="Wrapper"] {
                > div[class^="GridWrapper"] {
                    > div[class^="GridOffset"] {
                        display: flex;
                        > div[class^="GridItemStyle"] {
                            > div[class^="Wrapper"] {
                                height: 100%;
                                div[data-test-selector="CommonCustomWrapper"] {
                                    height: 100%;
                                }
                            }
                        }
                    }
                }
                .div-button {
                    .btn-contact-us {
                        cursor: pointer;
                        font-family: inherit;
                        height: 40px;
                        line-height: 1;
                        -webkit-backface-visibility: hidden;
                        backface-visibility: hidden;
                        -webkit-transition: all 200ms ease-in-out;
                        transition: all 200ms ease-in-out;
                        padding: 0 21px;
                        border: 2px solid #275aa8;
                        background: #275aa8;
                        color: #fff;
                        font-weight: 600;
                        &:hover {
                            background: #fff;
                            color: #275aa8;
                            span {
                                color: #275aa8;
                            }
                        }
                        a {
                            outline: none;
                        }
                        span {
                            font-size: 15px;
                            font-weight: bold;
                            color: #fff;
                        }
                        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                        height: 50px;
                                    `,
                    ],
                    "max",
                )}
                    }
                }
            }
        `,
    },
};

const styles = EqualHeightContainerStyles;

const EqualHeightContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="EqualHeightContainer">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: EqualHeightContainer,
    definition: {
        displayName: "Equal Height Container",
        group: "Common",
    },
};

export default widgetModule;
